export enum SelectLocationConfiguration {
  AddLocation = 'AddLocation',
  SetProximityToolStartLocation = 'SetProximityToolStartLocation'
}

export type SelectLocationState = Readonly<{
  active: boolean;
  isAddressLookupLoading?: boolean;
  configuration?: SelectLocationConfiguration;
}>;
